/* src/app/modules/institutions/institutions/institutions.component.scss */
:host {
  width: 100%;
}
/*# sourceMappingURL=institutions.component.css.map */
